import { useSidepanelViewAreaHeight } from '../atoms'
import { floatingBarContentMaxHeight } from '../components/sidepanel/nested/floating-bar-height'
import { SIDEPANEL_GUTTER_PX } from '../constants'

/**
 * The tallest a card standing in the floating bar may be before it has to
 * scroll; `undefined` until the panel has been measured. See
 * {@link floatingBarContentMaxHeight}.
 */
export function useFloatingBarContentMaxHeight(): number | undefined {
  const viewAreaHeight = useSidepanelViewAreaHeight()
  return floatingBarContentMaxHeight(viewAreaHeight, SIDEPANEL_GUTTER_PX)
}
